module.exports = __webpack_public_path__ + "img/feature-4.da7e6ed0.png";